export default __webpack_public_path__ + "static/media/avatar_meo.5d430115.jpg";